/* EDELHOLZ Konfigurator B + PDP - Endbild "So steht er bei dir" (14.10.2026).
   Zeigt in der Zusammenfassung das KI-Raumbild zur Konfiguration (Modell x Holzart) und laesst Boden und Wand umschalten.
   Bilder: Shopify Files eh-raum-<desk|arc>-<holzart>_<NN>.jpg (4:5, 1200 px), Quelle Ads-Pipeline "12 Final gleiche Kamera 2026-10-13".
   Motivnummer je Boden x Wand x Pflanze wie im Berater-Prototyp (raum_manifest.json), in beiden Saetzen gleich.
   Kein KI-Badge (Philipp 14.10.: das Produkt ist real, der Raum nur Orientierung). */
(function () {
  'use strict';
  var CDN = 'https://cdn.shopify.com/s/files/1/0844/1272/7641/files/';
  var N = { teppich:{lamelle:{gruen:1,pur:2}, weiss:{gruen:14,pur:3}, dunkel:{gruen:4,pur:5}},
            eiche:  {lamelle:{gruen:6,pur:16}, weiss:{gruen:7,pur:8},  dunkel:{gruen:15,pur:9}},
            fliese: {lamelle:{gruen:19,pur:10},weiss:{gruen:11,pur:12}, dunkel:{gruen:18,pur:17}},
            altbau: {lamelle:{gruen:24,pur:23},weiss:{gruen:20,pur:13}, dunkel:{gruen:22,pur:21}} };
  /* 15.10. SaphirSHIELD: eigener Bildsatz eh-raum-desk-<holzart>_<NN>-saphir.jpg (Ads-Pipeline), nur gerader Tisch und nur die 12 Motive mit Pflanze.
     SAPHIR erst auf true, wenn alle 48 Dateien im CDN liegen; sonst Fallback ohne Blende. */
  var SAPHIR = true; /* 15.10.: alle 48 Dateien im CDN */
  var SLUG = { 'golden timber':'golden-timber', 'deep walnut':'deep-walnut', 'midnight noir':'midnight-noir', 'smoked amber':'smoked-amber' };
  var BODEN = [['eiche','Eichenparkett'],['teppich','Grauer Teppich'],['fliese','Graue Fliese'],['altbau','Altbau, Fischgrät']];
  var WAND  = [['weiss','Weiß'],['dunkel','Dunkel'],['lamelle','Holzlamellen']];
  var wahl = { boden:'eiche', wand:'weiss', pflanze:'gruen' };
  try { var g = JSON.parse(sessionStorage.getItem('ehRaumWahl') || 'null'); if (g && N[g.boden] && N[g.boden][g.wand]) { wahl.boden = g.boden; wahl.wand = g.wand; } } catch (e) {}

  /* 14.10. Messung (Ads-Pipeline, Tracker-Feld EH_LP_Endbild): position pdp|konfigurator, aktion ansicht|holz|boden|wand, section = Wert.
     Als eh:track an assets/edelholz-mess-beacon.js, dort Dedupe je Seitenaufruf und Consent. */
  function melden(position, aktion, section) {
    try { window.dispatchEvent(new CustomEvent('eh:track', { detail: { name: 'endbild', data: { position: position, aktion: aktion, section: section || '' } } })); } catch (e) {}
  }
  function ansichtMelden(box, position) {
    if (!('IntersectionObserver' in window)) return;
    try {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting && !box.hidden) { melden(position, 'ansicht', position); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(box.querySelector('.ehb-raum__stage') || box);
    } catch (e) {}
  }
  function stand() {
    try {
      var d = (window.edelholzKonfig && window.edelholzKonfig.getCurrentConfigData) ? window.edelholzKonfig.getCurrentConfigData() : null;
      if (d) d.saphir = /saphirshield/i.test(String(d.addons || '')); /* Add-on-String des Konfigurators, Titel 'SaphirSHIELD' */
      return d;
    } catch (e) { return null; }
  }
  function satzSlug(d) {
    if (!d || !d.model) return null;
    var slug = SLUG[String(d.finish || '').trim().toLowerCase().replace(/^sonderfinish\s+/, '')];
    if (!slug) return null;
    var satz = /arc/i.test(d.model) ? 'arc' : 'desk';
    return { satz: satz, slug: slug, saphir: !!(SAPHIR && satz === 'desk' && d.saphir) };
  }
  function urlFuer(ss, boden, wand, breite) {
    var n = N[boden][wand][wahl.pflanze];
    /* v= nach jedem Ersatz der Raumbilder hochzaehlen (CDN-Cache); 20261014c = Satz 'Final Massstab' */
    var blende = (ss.saphir && wahl.pflanze === 'gruen') ? '-saphir' : ''; /* Saphir-Satz gibt es nur fuer die Pflanzen-Motive */
    return CDN + 'eh-raum-' + ss.satz + '-' + ss.slug + '_' + (n < 10 ? '0' : '') + n + blende + '.jpg?v=20261014c' + (breite ? '&width=' + breite : '');
  }
  function bildUrl(d) { var ss = satzSlug(d); return ss ? urlFuer(ss, wahl.boden, wahl.wand) : null; }

  function markup() {
    return '<div class="ehb-raum__kopfzeile"><p class="ehb-raum__kopf">So steht er bei dir.</p>' +
        '<p class="ehb-raum__sub">Dein Modell in deiner Holzart, Raum zur Orientierung. Boden und Wand kannst du anpassen.</p></div>' +
      '<div class="ehb-raum__stage"><img class="ehb-raum__img" alt="Dein konfigurierter Schreibtisch im Raum" width="960" height="1200" loading="lazy" decoding="async"></div>' +
      '<div class="ehb-raum__gruppe"><p class="ehb-raum__lbl">Boden</p><div class="ehb-raum__chips" role="group" aria-label="Boden" data-k="boden"></div></div>' +
      '<div class="ehb-raum__gruppe"><p class="ehb-raum__lbl">Wand</p><div class="ehb-raum__chips" role="group" aria-label="Wand" data-k="wand"></div></div>';
  }
  /* 14.10. (Philipp): Boden und Wand als kleine Bildkacheln statt Textpillen - greifbarer, wie die Finish-Wahl. Bilder 320 px aus dem CDN. */
  function chips(box, k, liste) {
    var c = box.querySelector('[data-k="' + k + '"]');
    c.innerHTML = liste.map(function (e) {
      return '<button type="button" class="ehb-raum__chip" data-v="' + e[0] + '" aria-pressed="' + (wahl[k] === e[0]) + '">' +
        '<span class="ehb-raum__chipbild"><img alt="" loading="lazy" decoding="async"></span><span class="ehb-raum__chiptext">' + e[1] + '</span></button>';
    }).join('');
  }
  /* 14.10. (Philipp): Material-Swatches wie die Finish-Kacheln (KI-erzeugte Nahaufnahmen, Shopify Files eh-raum-swatch-<key>.jpg), nicht die Raumbilder. */
  /* Holzlamellen zeigen die gewaehlte Holzart (eh-raum-swatch-lamelle-<holzart>.jpg), alles andere ist fest. */
  function chipBilder(box, standFn) {
    var ss = satzSlug(standFn());
    [].forEach.call(box.querySelectorAll('.ehb-raum__chip'), function (b) {
      var k = b.getAttribute('data-v');
      var u = CDN + 'eh-raum-swatch-' + k + (k === 'lamelle' && ss ? '-' + ss.slug : '') + '.jpg?width=240&v=20261014d'; /* v= bei ersetzten Dateien hochzaehlen (CDN-Cache) */
      var im = b.querySelector('img'); if (im.getAttribute('src') !== u) im.src = u;
    });
  }
  function macheZeichnen(box, img, standFn, position) {
    var aktuell = '', holzAktuell = '', blendeAktuell = null;
    return function zeichnen() {
      var ss = satzSlug(standFn());
      if (ss && holzAktuell && ss.slug !== holzAktuell) melden(position, 'holz', ss.slug);
      if (ss) holzAktuell = ss.slug;
      if (ss && blendeAktuell !== null && ss.saphir !== blendeAktuell) melden(position, 'blende', ss.saphir ? 'saphir' : 'ohne');
      if (ss) blendeAktuell = ss.saphir;
      var url = bildUrl(standFn());
      if (!url) { box.hidden = true; return; }
      box.hidden = false;
      chipBilder(box, standFn);
      if (url === aktuell) return;
      aktuell = url;
      img.classList.add('is-wechsel');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        if (aktuell !== url) return;
        img.src = url;
        img.classList.remove('is-wechsel');
        var th = box.querySelector('.ehb-raum__thumb'); if (th) th.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
      };
      pre.src = url;
    };
  }
  function chipKlicks(box, zeichnen, position) {
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('.ehb-raum__chip'); if (!btn) return;
      var k = btn.parentElement.getAttribute('data-k'), v = btn.getAttribute('data-v');
      if (!k || !v || wahl[k] === v) return;
      wahl[k] = v;
      [].forEach.call(btn.parentElement.querySelectorAll('.ehb-raum__chip'), function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      try { sessionStorage.setItem('ehRaumWahl', JSON.stringify({ boden: wahl.boden, wand: wahl.wand })); } catch (e) {}
      try { window.dataLayer && window.dataLayer.push({ event: 'konfig_raumbild', raum_boden: wahl.boden, raum_wand: wahl.wand }); } catch (e) {}
      melden(position, k, v);
      zeichnen();
    });
  }

  /* ---------- Konfigurator B: Block in der Zusammenfassung nach der Zeilenliste ---------- */
  function init(wurzel) {
    var sumwrap = wurzel.querySelector('.ehb-step--sum .ehb-sumwrap');
    var summary = sumwrap && sumwrap.querySelector('.eh-summary');
    if (!summary || sumwrap.querySelector('.ehb-raum')) return;
    var box = document.createElement('div');
    box.className = 'ehb-raum';
    box.setAttribute('data-ehb-raum', '');
    box.hidden = true;
    box.innerHTML = markup();
    /* 14.10. Philipp: nicht zwischen Liste und Kaufknopf, sondern ganz unten nach Warenkorb/Angebot/USPs, volle Spaltenbreite. */
    var actions = sumwrap.querySelector('.eh-actions');
    (actions || summary).insertAdjacentElement('afterend', box);
    var img = box.querySelector('.ehb-raum__img');
    chips(box, 'boden', BODEN); chips(box, 'wand', WAND);
    var zeichnen = macheZeichnen(box, img, stand, 'konfigurator');
    chipKlicks(box, zeichnen, 'konfigurator');
    ansichtMelden(box, 'konfigurator');
    var t;
    function spaeter() { clearTimeout(t); t = setTimeout(zeichnen, 160); }
    wurzel.addEventListener('change', spaeter, true);
    wurzel.addEventListener('click', function (e) { if (!box.contains(e.target)) spaeter(); }, true);
    try { new MutationObserver(spaeter).observe(summary, { childList: true }); } catch (e) {}
    /* A-JS initialisiert spaeter als dieses Skript: bis zu 6 s auf getCurrentConfigData warten */
    var versuche = 0;
    (function warten() {
      if (stand()) { zeichnen(); return; }
      if (++versuche < 40) setTimeout(warten, 150);
    })();
  }

  /* ---------- PDP (edelholz-pdp-minikonfigurator): Block unter der Kaufbox, Finish aus dem aktiven Swatch ---------- */
  function initPdp(root) {
    var cfg = null;
    try { cfg = JSON.parse(root.querySelector('[data-mk-config]').textContent); } catch (e) {}
    var model = cfg && cfg.model;
    if (!model || !/^(DeskPRO|DeskPURE|ArcPURE)$/i.test(model)) return;
    var usps = root.querySelector('.eh-mk__usps');
    var anker = usps ? usps.parentElement : null;
    if (!anker || root.querySelector('.ehb-raum')) return;
    var box = document.createElement('div');
    box.className = 'ehb-raum ehb-raum--pdp';
    box.hidden = true;
    /* 14.10. (Philipp): auf der PDP eingeklappt wie die Ausstattung - eine Zeile mit Vorschaubild, aufklappbar, sonst wird die Seite zu lang. */
    box.innerHTML = '<button type="button" class="ehb-raum__toggle" aria-expanded="false">' +
        '<span class="ehb-raum__toggle-bild"><img class="ehb-raum__thumb" alt="" width="56" height="56" loading="lazy"></span>' +
        '<span class="ehb-raum__toggle-text"><strong>So steht er bei dir.</strong><small>Dein Modell in deiner Holzart, in einem Raum wie deinem</small></span>' +
        '<span class="ehb-raum__toggle-chev">Ansehen \u203a</span></button>' +
      '<div class="ehb-raum__inhalt" hidden>' + markup() + '</div>';
    anker.insertAdjacentElement('afterend', box);
    var tg = box.querySelector('.ehb-raum__toggle'), inhalt = box.querySelector('.ehb-raum__inhalt');
    tg.addEventListener('click', function () {
      var offen = inhalt.hidden; inhalt.hidden = !offen; tg.setAttribute('aria-expanded', String(offen));
      tg.querySelector('.ehb-raum__toggle-chev').textContent = offen ? 'Schlie\u00dfen' : 'Ansehen \u203a';
      try { window.dataLayer && window.dataLayer.push({ event: 'pdp_raumbild', offen: offen }); } catch (e) {}
      if (offen) melden('pdp', 'ansicht', 'pdp');
    });
    var img = box.querySelector('.ehb-raum__img');
    chips(box, 'boden', BODEN); chips(box, 'wand', WAND);
    function standPdp() {
      var sw = root.querySelector('[data-mk-finish].aktiv');
      return { model: model, finish: sw ? sw.getAttribute('data-mk-finish') : '', saphir: !!root.querySelector('[data-mk-addon="saphir"].aktiv') };
    }
    var zeichnen = macheZeichnen(box, img, standPdp, 'pdp');
    chipKlicks(box, zeichnen, 'pdp');
    var t;
    root.addEventListener('click', function (e) { if (!box.contains(e.target)) { clearTimeout(t); t = setTimeout(zeichnen, 160); } }, true);
    zeichnen();
  }

  function start() {
    [].forEach.call(document.querySelectorAll('.eh-b'), function (w) { if (!w.__ehRaum) { w.__ehRaum = true; init(w); } });
    [].forEach.call(document.querySelectorAll('[data-eh-mk]'), function (w) { if (!w.__ehRaum) { w.__ehRaum = true; initPdp(w); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  setTimeout(start, 1200);
})();
